export default __webpack_public_path__ + "static/media/plus.19c83902.svg";